import React, { useEffect, useRef, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import {
  deleteStaff,
  deleteTaskTemp,
  getTaskTempList,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { FormateDate, formatTimeDuration } from "../../../../utils/FormateDate";
import { ExtractDays } from "../../../../utils/ExtractDays";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ConfirmationModal } from "../../../../components/Modals/ConfirmationModal";
import TruncateText from "../../../../utils/TruncateText";
import { useStateValue } from "../../../../StateProvider";
import { IoMdSearch } from "react-icons/io";

const TaskTempList = () => {
  const navigate = useNavigate();
  const [{ sysConfig }, dispatch] = useStateValue();

  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");
  const fetchTaskTemp = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await getTaskTempList();
      console.log(response);
      if (response?.status === 200) {
        setTaskTempList(response.data.data);
        setFilteredData(response.data.data);
        // setTaskTempList(dummyData);
        // setFilteredData(dummyData);
        // refetch();
      } else if(response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const removeTaskTemp = async (id) => {
    // Perform the API call to fetch company info
    try {
      const response = await deleteTaskTemp(id);
      console.log(response);
      if (response?.status === 200) {
        refetch();
        toast.success(response.data.message);
      } else {
        response?.response?.status(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const {
    isLoading,
    isFetching,
    data: taskTempListData,
    refetch,
  } = useQuery({
    queryKey: ["task-temp-list"],
    queryFn: () => fetchTaskTemp(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [taskTempList, setTaskTempList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const searchInputWeb = useRef(null);
  const searchInputMobile = useRef(null);

  useEffect(() => {
    filterData(searchQuery);
  }, [searchQuery,taskTempList]);
  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(totalPageCount);
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [currentPage, filteredData]);

  const handleSearch = (e) => {
    if (taskId) {
      removeSelection();
    }
    let query
    if (window.innerWidth >= 767) {

      query = searchInputWeb.current.value.toLowerCase();
    }
    else {
      query = searchInputMobile.current.value.toLowerCase();

    }
    setSearchQuery(query);
    // filterData(query, typeFilter, isActiveFilter);
  };
  const filterData = (query) => {
    let filtered = taskTempList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Dscr.toString().toLowerCase().includes(query) ||
          item.Name.toString().toLowerCase().includes(query)
        //|| item.Mobile.includes(query)
      );
    }
    // if ((buttonRef.current && isFilterOpen && filtered.length > 0)) {
    //   buttonRef.current.click();
    // }
    if ((buttonRef.current && isFilterOpen && filtered.length > 0)) {
      buttonRef.current.click();
    }
    setFilteredData(filtered);
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (taskId) {
      const targetIndex = filteredData.findIndex((item) => {
        console.log(item.ID);
        return item.ID === parseInt(taskId);
      });
      console.log(targetIndex, filteredData);
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber);
      setCurrentPage(pageNumber);
    }
  }, [taskId, filteredData]);
  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);
  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);

  const removeSelection = () => {
    navigate("/task-template");
  };
  // ****************************************** accordion start *********************************************
  const statusTitle = (status, projectType) => {
    if (projectType === "over_due") {
      return "List of Over due Project";
    } else if (status === "1" || projectType === "up_coming") {
      return "List of Up Coming Project";
    } else if (status === "2" || projectType === "on_going") {
      return "List of On Going Project";
    } else if (status === "3" || projectType === "under_review") {
      return "List of Under Review Project";
    } else if (status === "4") {
      return "List of Completed Project";
    } else if (status === "5") {
      return "List of Cancelled Project";
    } else {
      return "List of Project";
    }
  };
  const [isFilterOpen, setIsFilterOpend] = useState(true)
  const collapseRef = useRef(null);
  const buttonRef = useRef(null);


  useEffect(() => {
    // Ensure the ref points to the correct element
    const collapseElement = collapseRef.current;

    // Event listener for when the accordion is opened
    const handleShown = () => {
      console.log('Accordion is opened');
      setIsFilterOpend(true)
    };

    // Event listener for when the accordion is closed
    const handleHidden = () => {
      setIsFilterOpend(false)

      console.log('Accordion is closed');
    };

    // Attach event listeners for Bootstrap collapse events
    collapseElement.addEventListener('shown.bs.collapse', handleShown);
    collapseElement.addEventListener('hidden.bs.collapse', handleHidden);

    // Cleanup listeners when component unmounts
    return () => {
      collapseElement.removeEventListener('shown.bs.collapse', handleShown);
      collapseElement.removeEventListener('hidden.bs.collapse', handleHidden);
    };
  }, []);
  // ****************************************** accordion end *********************************************
  // ****************************************** accordion close when click outside start *********************************************
  const handleClickOutside = (event) => {
    if (collapseRef.current && !collapseRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      const collapseInstance = new window.bootstrap.Collapse(collapseRef.current, {
        toggle: false
      });
      collapseInstance.hide();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // ****************************************** accordion close when click outside end *********************************************
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area">
        <div className="container-fluid">
          <div className="row web-view">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              <div className="mb-5">
                <h3 className="mb-0 ">List of Task Template</h3>
              </div>
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-12">
                {/* card */}
                <div className="card ">
                  <div className="accordion position-absolute w-100 z-3 mobile-view" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header bg-white" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
                          data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          <strong>

                            List of Task Template
                          </strong>
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" ref={collapseRef}
                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">

                        <div className="card-header  ">
                          <div className="row justify-content-between gap-3">
                            <div className=" col-lg-4 col-md-6 mt-md-3 d-flex">
                              <input
                                type="search"
                                className="form-control "
                                ref={searchInputMobile}
                                onChange={(e) => {
                                  if (e.target.value === "") {
                                    handleSearch();
                                  }
                                }}
                                placeholder="Search for name or description."
                              />
                              <div
                                className="btn btn-primary ms-3"
                                onClick={() => handleSearch()}
                              >
                                <IoMdSearch size={25} />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-5 mb-3 d-flex justify-content-end ">
                              <div
                                className="btn btn-primary  w-100"
                                onClick={() => {
                                  navigate("/add/task-template");
                                }}
                              >
                                + Add Task Template
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-header web-view   ">
                    <div className="row justify-content-between gap-4">
                      <div className=" col-lg-4 col-md-6  d-flex ">
                        <input
                          type="search"
                          className="form-control "
                          // value={searchQuery}
                          ref={searchInputWeb}
                          onChange={(e) => {
                            if (e.target.value === "") {
                              handleSearch();
                            }
                          }}
                          // onChange={handleSearch}
                          placeholder="Search for name or description."
                        />
                        <div
                          className="btn btn-primary ms-3"
                          onClick={() => handleSearch()}
                        >
                          <IoMdSearch size={25} />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-5  d-flex justify-content-end ">
                        <div
                          className="btn btn-primary  w-100"
                          onClick={() => {
                            navigate("/add/task-template");
                          }}
                        >
                          + Add Task Template
                        </div>
                      </div>
                    </div>
                  </div>
                  {!isFetching ? (
                    <>
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          {currentItems.length > 0 ? (
                            <table className="table text-nowrap mb-0 responsive-table main-table sub-table table-centered table-hover">
                              <thead className="table-light">
                                <tr>
                                  <th className="ps-6">Name</th>
                                  <th>Description</th>
                                  <th>Approx Duration</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {currentItems.map((temp, index) => (
                                  <tr
                                    id={`task-temp-${temp?.ID}`}
                                    className={`${parseInt(taskId) === temp?.ID
                                      ? "table-primary"
                                      : ""
                                      }`}
                                  >
                                    <td
                                      className="name"
                                      style={{
                                        maxWidth: "300px",
                                        textWrap: "wrap",
                                      }}
                                    >
                                      {temp?.Name}
                                    </td>

                                    <td
                                      // data-label1="Description"
                                      className="name"
                                      style={{
                                        maxWidth: "300px",
                                        textWrap: "wrap",
                                      }}
                                    >
                                      <div className="truncate">
                                        {temp?.Dscr}
                                      </div>
                                    </td>
                                    <td
                                      data-label1="Approx Duration"
                                      style={{ width: "150px" }}>
                                      {temp?.AprxDuration === "0 days, 00:00"
                                        ? "---"
                                        : formatTimeDuration(temp?.AprxDuration)}
                                    </td>

                                    <td
                                      data-label1="Action"

                                      style={{ width: "120px" }}>
                                      <div className="d-flex">

                                        <div
                                          className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                          data-template="editOne"
                                          onClick={() => {
                                            navigate(
                                              `/update/task-template/${temp?.ID}`
                                            );
                                            // setEditTaskTempData(temp);
                                            // setActiveTab("addUpdateTaskTemp");
                                          }}
                                        >
                                          <FaRegEdit size={18} />
                                          <div id="editOne" className="d-none">
                                            <span>Edit</span>
                                          </div>
                                        </div>
                                        <div
                                          className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                          data-template="trashOne"
                                          onClick={() => {
                                            handleConfirmationShow();
                                            removeSelection();
                                            setFunHandler({
                                              fun: removeTaskTemp,
                                              id: temp?.ID,
                                              title: "delete task template",
                                            });
                                          }}
                                        >
                                          <MdOutlineDelete size={18} />
                                          <div id="trashOne" className="d-none">
                                            <span>Delete</span>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div className={` fs-3 ${isFilterOpen ? "show-md-margin" : "hidden-md-margin"}`}>
                              <strong>No records found.!</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      {filteredData.length > 0 && (
                        <div className="card-footer d-md-flex justify-content-between align-items-center">
                          <span>
                            Showing{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) -
                              Number(sysConfig["Rows in MultiLine List"]) +
                              1}{" "}
                            to{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) >=
                              filteredData.length
                              ? filteredData.length
                              : currentPage *
                              Number(
                                sysConfig["Rows in MultiLine List"]
                              )}{" "}
                            of {filteredData.length} entries
                          </span>
                          <nav className="mt-2 mt-md-0">
                            <ul className="pagination mb-0 ">
                              <li
                                className="page-item "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    removeSelection();
                                    handlePageChange(currentPage - 1);
                                  }
                                }}
                              >
                                <div
                                  className={`page-link ${currentPage === 1 ? "disabled" : ""
                                    } `}
                                >
                                  Previous
                                </div>
                              </li>
                              {Array(totalPages ? totalPages : 0)
                                .fill()
                                .map((item, index) => (
                                  <li
                                    style={{ cursor: "pointer" }}
                                    className={`${currentPage === index + 1
                                      ? "page-item active"
                                      : "page-item"
                                      } ${currentPage + 2 >= index + 1 &&
                                        index + 1 > currentPage - 2
                                        ? // currentPage - 2 < index + 1
                                        "d-block"
                                        : "d-none"
                                      }`}
                                    onClick={() => {
                                      handlePageChange(index + 1);
                                      removeSelection();
                                    }}
                                  >
                                    <div className="page-link">{index + 1}</div>
                                  </li>
                                ))}

                              {/* <li className="page-item">
                            <a className="page-link" href="#!">
                              2
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#!">
                              3
                            </a>
                          </li> */}
                              <li className="page-item">
                                <div
                                  style={{ cursor: "pointer" }}
                                  className={`page-link ${totalPages === currentPage ? "disabled" : ""
                                    } `}
                                  onClick={() => {
                                    if (totalPages > currentPage) {
                                      removeSelection();
                                      handlePageChange(currentPage + 1);
                                    }
                                  }}
                                >
                                  Next
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>Fetching records..</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default TaskTempList;
